// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__31f1N","title":"FrontImage_title__13TQc"};